// JS file for Search
const favoritedBtns = document.querySelectorAll('[uni-favorite-button]');

favoritedBtns.forEach((e) => {
  const $this = e;

  $this.addEventListener('favorited', () => {
    $this.blur();
  });
});
